import type { UnsavedLibraryBlockEntity } from '@web/store/library-blocks/library-blocks.models';

import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as LibraryBlocksActions from './library-blocks.actions';
import * as LibraryBlocksSelectors from './library-blocks.selectors';

@Injectable()
export class LibraryBlockFacade {
    private readonly store = inject(Store);

    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    public readonly loaded$ = this.store.pipe(select(LibraryBlocksSelectors.selectLibraryBlocksLoaded));
    public readonly allLibraryBlocks$ = this.store.pipe(select(LibraryBlocksSelectors.selectAllLibraryBlocks));
    public readonly libraryBlocksEntities$ = this.store.pipe(
        select(LibraryBlocksSelectors.selectLibraryBlocksEntities)
    );
    public readonly libraryBlock$ = (blockId: string) =>
        this.store.select(LibraryBlocksSelectors.selectLibraryBlock(blockId));
    public readonly groupedLibraryBlocks$ = this.store.select(LibraryBlocksSelectors.selectGroupedLibraryBlocks);

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    public init(): void {
        this.store.dispatch(LibraryBlocksActions.initLibraryBlocks());
    }

    public initUserBlocks(): void {
        this.store.dispatch(LibraryBlocksActions.initUserLibraryBlocks());
    }

    public upsertLibraryBlock(libraryBlock: UnsavedLibraryBlockEntity): void {
        this.store.dispatch(LibraryBlocksActions.upsertLibraryBlock({ libraryBlock }));
    }

    public markLibraryBlockAsDeleted(blockId: string): void {
        this.store.dispatch(LibraryBlocksActions.markAsDeleted({ blockId }));
    }

    public removeLibraryBlock(blockId: string): void {
        this.store.dispatch(LibraryBlocksActions.removeLibraryBlock({ blockId }));
    }
}
